<template>
  <div class="layout-content">
    <ul class="layout-menu">
      <li :class="{'selected': routePath === menuItem.path}" v-for="menuItem in menuList" @click="jumpTo(menuItem.path)">
        <div>
          <img width="16%" :src="'/static/icon/' + menuItem.icon + '.png'" alt="">
          <span>{{ menuItem.title }}</span>
        </div>
      </li>
    </ul>
    <div class="layout-mainapp">
      <router-view></router-view>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      menuList: [
        { path: '/home', title: '现场管理', icon: 'saftyhat' },
        { path: '/groupTalk', title: '群组通话', icon: 'group' },
        { path: '/alarmLog', title: '报警记录', icon: 'alarm' },
        { path: '/photoManage', title: '照片管理', icon: 'photo' },
      ],
      selectedIndex: null
    }
  },
  computed: {
    routePath() {
      return this.$route.path
    }
  },
  mounted() {
    let submitForm = {
      // 建工账号
      userName: 'CS916V',
      pwd: 'CS123456dl@',
      
      // 官方test 【测试时，不要多人一起登录！】
      // userName: 'CSDL',
      // pwd: 'cs123456DL@',
      hbInterval: 10
    }
    this.$store.dispatch("Login", submitForm).then((res) => {
      console.log('=login', res);
    })
  },
  methods: {
    jumpTo(path) {
      this.selectedIndex = path;
      this.$router.push(path)
    }
  },
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.layout-content {
  display: flex;
  padding: 0 1%;
  height: 100vh;

  // TODO 临时加上背景图
  background: url('/static/bg.png') no-repeat center / 100%;
}

.layout-menu {
  width: 8%;
  height: 100%;
  //background-color: red;

  >li{
    height: 5%;
    >div {
      height: 100%;
      width: 75%;
      display: flex;
      justify-content: center;
      align-items: center;
      color: #0BD6F5;
      font-size: 0.8rem;
      cursor: pointer;
      padding-left: 5%;

      >img {
        margin-right: 5%;
      }
    }
  }
}

.layout-mainapp {
  width: 92%;
  height: 100%;
  padding-left: 1%;
}

.selected {
  background: linear-gradient(90deg, rgba(0,157,255,0) 0%, rgba(0,71,194,0.47) 100%);
  border-radius: 0px 4px 4px 0px;
}
</style>



// WEBPACK FOOTER //
// layout.vue?206cb446